import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { DOMAIN_HOST } from 'reactApp/appHelpers/configHelpers';

// Адреса для настройки @vkontakte/superappkit
export const vkLoginDomain: string = getFeature('vk-login-domain') || 'login.vk.com';
export const vkOauthDomain: string = getFeature('vk-oauth-domain') || 'oauth.vk.com';
export const vkConnectDomain: string = getFeature('vk-connect-domain') || 'connect.vk.com';

// App id
const DEFAULT_VK_APP_ID = DOMAIN_HOST === 'mini-mail.ru' ? 51414545 : 7539952;
export const vKAppID: number = getFeature('vk-app-id') || DEFAULT_VK_APP_ID;
